


























































































import {Component, Vue} from 'vue-property-decorator';
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import {
	ServiceRecordDTO,
	ServiceRecordFilter
} from "@/components/payroll/business/services/ServiceDTO";
import Application from "@/state/Application";
import {processError} from "@/utils/ComponentUtils";
import ServiceRecordOrchestrator from "@/services/ServiceLogOrchestrator";
import TimeSheetDetails from "@/components/payroll/timesheet/TimeSheetDetails.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";
import {subSrtIfNeed} from "../../../../utils/StringUtils";
import ServiceInvoiceItem from "@/components/payroll/business/services/ServiceInvoiceItem.vue";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import AssignWorkServiceLog from "@/components/payroll/business/services/service/AssignWorkServiceLog.vue";
import ServiceLogUpdateSlider from "@/components/payroll/business/services/service/ServiceLogUpdateSlider.vue";
import ServiceLogViewSlider from "@/components/payroll/business/services/service/ServiceLogViewSlider.vue";
import moment from "moment/moment";

@Component({
	methods: {subSrtIfNeed},
	components: {
		ServiceLogViewSlider,
		ServiceLogUpdateSlider,
		AssignWorkServiceLog, ServiceInvoiceItem, ServiceLogView, TimeSheetDetails, PaginationComponent}
})
export default class EmployerServiceLogList extends Vue {

	private assignWork = false
	private updateLog = false;
	private viewLog = false;

	private records: Page<ServiceRecordDTO> = EMPTY_PAGE;
	private selectedLog: ServiceRecordDTO | null = null;

	private filter = new ServiceRecordFilter(
		{
			recipientId: this.$wss.getCurrent.id,
		}
	)

	mounted() {
		this.loadServiceRecords()
	}

	private loadServiceRecords() {
    this.$loadOn()
		return ServiceRecordOrchestrator.getPageByFilter(this.filter).then(
			res => {
        this.records = res.data
        this.$loadOff()
      },
			err => processError(err, this)
		)
	}

	private reload() {
    this.loadServiceRecords()
	}

	private loadPage(page: number) {
		this.filter.page = page - 1
		this.loadServiceRecords()
	}

	private loadNextPage() {
		this.filter.page = this.filter.page + 1
		this.loadServiceRecords()
	}

	private close(record: ServiceRecordDTO) {
		(this.$refs[`popover_${record.id}`] as Array<Vue>)[0].$emit("close")
	}

	private disable(record: ServiceRecordDTO) {
		this.$modal.show(
			DeleteConfirmation,
			{
				onDelete: () => {
					Application.startLoading()
					ServiceRecordOrchestrator.disableLog(record.id, record.executor.id).then(
						() => {
							return Promise.all(
								[
									this.loadServiceRecords(),
								]
							)
						},
						err => processError(err, this)
					).finally(Application.stopLoading)
				},
				targetName: `"${record.title}"`,
				operationName: 'disable'
			}
		)
	}

	private update() {
		Application.startLoading()
		return Promise.all(
			[
				this.loadServiceRecords(),
			]
		).finally(Application.stopLoading)
	}

	private openLog(log: ServiceRecordDTO) {
		this.selectedLog = log
		if (log.executor.userId == this.$wss.getCurrent.userId) {
			this.updateLog = true;
		} else {
			this.viewLog = true;
		}
	}

	private formatDate(date: Date): string {
		return moment(date).format("MMM D");
	}
}
